import {
  Target, BookOpen, Lightbulb, Layers, GraduationCap, CheckCircle2,
  Eye, FlaskConical, ListChecks, Brain, Puzzle, ArrowRight,
  HelpCircle, Clipboard, Star, Sparkles, TrendingUp, Microscope,
  Scale, Workflow, BookMarked, PenTool, type LucideIcon,
} from "lucide-react";

/**
 * Maps keywords in section headings to thematic icons.
 * Used in revision sheet rendering to add visual anchors to sections.
 */
const ICON_RULES: { keywords: RegExp; icon: LucideIcon }[] = [
  // Objectives / Goals
  { keywords: /objecti|goal|aim|but|learning\s*outcome/i, icon: Target },
  // Definitions
  { keywords: /defini|what\s*is|qu['']est/i, icon: BookMarked },
  // Visual Overview / Diagrams
  { keywords: /visual|overview|diagram|aperçu|vue\s*d['']ensemble/i, icon: Eye },
  // Concept Breakdown / Key Concepts
  { keywords: /concept|décomposition|breakdown|key\s*point|notion/i, icon: Layers },
  // Explanation
  { keywords: /expla|explica|pédagog/i, icon: Lightbulb },
  // Examples
  { keywords: /example|exemple|illustration|cas\s*pratique|concret/i, icon: FlaskConical },
  // Key Takeaways / Summary
  { keywords: /takeaway|retenir|résumé|summary|essentiel|remember|point.*clé/i, icon: CheckCircle2 },
  // Practice / Exercises
  { keywords: /practice|exerci|entraîn|drill/i, icon: PenTool },
  // Quiz / Questions / Test
  { keywords: /quiz|question|test|évalua/i, icon: HelpCircle },
  // Analysis / Method
  { keywords: /analy|method|métho|approach|démarche/i, icon: Microscope },
  // Comparison
  { keywords: /compar|vs\b|versus|differ/i, icon: Scale },
  // Process / Steps / Workflow
  { keywords: /process|étape|step|workflow|procéd/i, icon: Workflow },
  // Tips / Advice
  { keywords: /tip|conseil|astuce|advice|recommand/i, icon: Star },
  // Progress / Results
  { keywords: /progress|résultat|result|performanc/i, icon: TrendingUp },
  // Introduction
  { keywords: /introd|présentation|context/i, icon: BookOpen },
  // Conclusion
  { keywords: /conclu|synthèse|bilan|wrap/i, icon: Clipboard },
  // Challenges / Difficulties
  { keywords: /challeng|difficulté|piège|mistake|erreur|common\s*pitfall/i, icon: Puzzle },
  // Deep Dive / Details
  { keywords: /deep\s*dive|détail|approfond|further/i, icon: Brain },
  // List / Checklist
  { keywords: /checklist|liste|inventory/i, icon: ListChecks },
];

/** Default fallback icon for unmatched sections */
const DEFAULT_ICON: LucideIcon = Sparkles;

/**
 * Returns the best matching Lucide icon for a given section heading text.
 */
export function getSectionIcon(heading: string): LucideIcon {
  for (const rule of ICON_RULES) {
    if (rule.keywords.test(heading)) {
      return rule.icon;
    }
  }
  return DEFAULT_ICON;
}
